export default "__VITE_ASSET__CLwx17Gu__"